<template>
  <div class="container">
    <div class="card">
      <h1 class="title">减碳目标<sup>1</sup></h1>
      <p class="year">2030年</p>

      <div class="stats">
        <div class="stat">
          <p class="label">范围1及范围2减碳<sup>2</sup></p>
          <p class="value">42%</p>
        </div>
        <div class="stat">
          <p class="label">范围3减碳<sup>3</sup></p>
          <p class="value">42%</p>
        </div>
        <div class="stat">
          <p class="label">累计减碳<sup>4</sup></p>
          <p class="value">50.8 <span class="unit">万吨</span></p>
        </div>
      </div>

      <div class="notes">
        <p>1.  绝对基准年为2021年。</p>
        <p>2.  范围1温室气体排放量，指栋下物业管理的24个项目公共区域及服务设施所消耗天然气、汽油、二氧化碳灭火器填充、冷媒填充产生的直接温室气体排放。范围2温室气体排放量，指栋下物业管理的24个项目公共区域及服务设施消耗的电力、外购热力和外购冷源所产生的间接温室气体排放。</p>
        <p>3.  范围3温室气体排放量，包括下游供应链产生的温室气体，包括类别1外购商品和服务的排放、类别11-终端产品使用阶段的排放、类别13-下游租赁资产的排放。</p>
        <p>4.  累计减碳数据是基于各目标年度每年减碳量的累加。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarbonReductionTarget",
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f3f4f6;
  padding: 20px;
}

.card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 30px;
  max-width: 600px;
  text-align: center;
}

.title {
  font-size: 28px;
  color: #009688;
  font-weight: bold;
}

.year {
  font-size: 20px;
  color: #333;
  margin-top: 10px;
}

.stats {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.stat {
  text-align: center;
}

.label {
  font-size: 16px;
  color: #666;
}

.value {
  font-size: 30px;
  font-weight: bold;
  color: #000;
}

.unit {
  font-size: 18px;
  font-weight: normal;
  color: #333;
}

.notes {
  text-align: left;
  margin-top: 20px;
  font-size: 12px;
  color: #666;
  border-top: 1px solid #ddd;
  padding-top: 10px;
  line-height: 1.5;
}
</style>
